import { render, staticRenderFns } from "./RegistrationPopup.vue?vue&type=template&id=b6353ee8&scoped=true"
import script from "./RegistrationPopup.vue?vue&type=script&lang=js"
export * from "./RegistrationPopup.vue?vue&type=script&lang=js"
import style0 from "./RegistrationPopup.vue?vue&type=style&index=0&id=b6353ee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6353ee8",
  null
  
)

export default component.exports